/* PDP V2 – Treue-Staffel im Abo: Preise je Lieferung bei Varianten- oder
   Kachelwechsel neu rechnen. Gleiche Rundung wie im Liquid (Rabatt
   abgerundet). Nur aktiv, wenn die Staffel gerendert wurde. */
(function () {
  'use strict';
  function euro(cents) {
    return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }
  function init(root) {
    var stufen = Array.prototype.slice.call(root.querySelectorAll('[data-treue-rabatt]'));
    if (!stufen.length) return;
    var cfg = {};
    try { cfg = JSON.parse(root.querySelector('[data-pdp2-config]').textContent); } catch (e) { return; }
    var varianten = cfg.variants || [];
    var input = root.querySelector('[data-pdp2-variant-input]');
    function update() {
      var id = input ? parseInt(input.value, 10) : 0;
      var v = varianten.filter(function (x) { return x.id === id; })[0] || varianten[0];
      if (!v) return;
      var kachel = root.querySelector('[data-tier].selected');
      var menge = kachel ? (parseInt(kachel.getAttribute('data-quantity'), 10) || 1) : 1;
      stufen.forEach(function (el) {
        var d = parseInt(el.getAttribute('data-treue-rabatt'), 10) || 0;
        var preisEl = el.querySelector('[data-treue-preis]');
        if (preisEl) preisEl.textContent = euro((v.price - Math.floor(v.price * d / 100)) * menge);
      });
    }
    root.addEventListener('change', function () { setTimeout(update, 0); });
    root.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-tier]')) setTimeout(update, 0);
    });
    update();
  }
  function boot() { document.querySelectorAll('[data-pdp2-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
